const $ = require('jquery');

$('.c-list_item label').click(function()
{
  $(this).parent('li').toggleClass('is-active');
});

$('.c-list_item_input').change(function ()
{
  let checked = $('.c-list_item_input:checked').length;

  if(checked>0)
  {
    $('.js-previewPDF').prop('disabled','');
    $('.js-generatePDF').prop('disabled','');
  }
  else
  {
    $('.js-previewPDF').prop('disabled','disabled');
    $('.js-generatePDF').prop('disabled','disabled');
  }
});